// // CustomCursor.jsx
// import React, { useEffect, useRef } from 'react';
// import { useLocation } from 'react-router-dom';
// import styles from './CustomCursor.module.css';

// export default function CustomCursor() {
//   const dotRef = useRef(null);
//   const ringRef = useRef(null);
//   const pos = useRef({ x: 0, y: 0 });
//   const ring = useRef({ x: 0, y: 0 });
//   const hovering = useRef(false);
//   const location = useLocation(); // Re-tracks listeners when transitioning routes

//   useEffect(() => {
//     const move = (e) => { 
//       pos.current = { x: e.clientX, y: e.clientY }; 
//     };
    
//     const onEnter = () => { hovering.current = true; };
//     const onLeave = () => { hovering.current = false; };

//     // Capture interactive elements on the current page view
//     const interactiveElements = document.querySelectorAll('a, button, [data-cursor]');
//     interactiveElements.forEach((el) => {
//       el.addEventListener('mouseenter', onEnter);
//       el.addEventListener('mouseleave', onLeave);
//     });

//     window.addEventListener('mousemove', move);

//     let raf;
//     const tick = () => {
//       const dot = dotRef.current;
//       const r = ringRef.current;
//       if (!dot || !r) { 
//         raf = requestAnimationFrame(tick); 
//         return; 
//       }
      
//       // Move pointer dot instantly
//       dot.style.transform = `translate(${pos.current.x - 4}px, ${pos.current.y - 4}px)`;
      
//       // Interpolate outer ring for a smooth fluid effect
//       ring.current.x += (pos.current.x - ring.current.x) * 0.12;
//       ring.current.y += (pos.current.y - ring.current.y) * 0.12;
      
//       const scale = hovering.current ? 2.2 : 1;
//       r.style.transform = `translate(${ring.current.x - 20}px, ${ring.current.y - 20}px) scale(${scale})`;
      
//       raf = requestAnimationFrame(tick);
//     };
    
//     tick();

//     // Clean up event listeners on unmount/route change
//     return () => {
//       cancelAnimationFrame(raf);
//       window.removeEventListener('mousemove', move);
//       interactiveElements.forEach((el) => {
//         el.removeEventListener('mouseenter', onEnter);
//         el.removeEventListener('mouseleave', onLeave);
//       });
//     };
//   }, [location]); // Re-executes when route updates

//   return (
//     <>
//       <div ref={dotRef} className={styles.cursorDot} aria-hidden="true" />
//       <div ref={ringRef} className={styles.cursorRing} aria-hidden="true" />
//     </>
//   );
// }


import React, { useEffect, useState } from 'react';
import styles from './CustomCursor.module.css';

export default function CustomCursor() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHoveringDark, setIsHoveringDark] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });

      // Detect if the cursor is currently over a dark section block
      const element = document.elementFromPoint(e.clientX, e.clientY);
      if (element) {
        // Checks if the element or its parent contains your dark section class names
        const insideDark = element.closest('[class*="darkSection"]') || element.closest('[class*="header"]');
        setIsHoveringDark(!!insideDark);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <>
      {/* Standard trailing ring */}
      <div 
        className={styles.cursorRing}
        style={{ transform: `translate3d(${position.x - 20}px, ${position.y - 20}px, 0)` }}
      />
      {/* Core pointer dot */}
      <div 
        className={styles.cursorDot}
        style={{ transform: `translate3d(${position.x - 4}px, ${position.y - 4}px, 0)` }}
      />
      {/* The trailing interactive glow gradient wrapper */}
      <div 
        className={`${styles.cursorGlow} ${isHoveringDark ? styles.activeGlow : ''}`}
        style={{ transform: `translate3d(${position.x - 250}px, ${position.y - 250}px, 0)` }}
      />
    </>
  );
}